/* SweepGuard – scripts propios */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sg-reveal:not(.sg-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('sg-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('sg-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-sg-count]');
    if (!els.length) return;
    function run(el) {
      var raw = (el.getAttribute('data-sg-count') || '').trim();
      if (!/^\d+(\.\d+)?$/.test(raw)) return;
      var target = parseFloat(raw), dec = (raw.split('.')[1] || '').length;
      if (reduce) { el.textContent = target.toFixed(dec); return; }
      var dur = parseInt(el.getAttribute('data-sg-duration') || '1600', 10), t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initScan(root) {
    (root || document).querySelectorAll('[data-sg-scan]').forEach(function (sec) {
      var modes = sec.querySelectorAll('.sg-mode'), imgs = sec.querySelectorAll('.sg-scan__frame img');
      if (!modes.length || !('IntersectionObserver' in window)) return;
      function activate(i) {
        modes.forEach(function (m, j) { m.classList.toggle('is-active', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) activate(Array.prototype.indexOf.call(modes, en.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      modes.forEach(function (m) { io.observe(m); });
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-sg-gallery]').forEach(function (g) {
      var main = g.querySelectorAll('.sg-gallery__main img'), thumbs = g.querySelectorAll('.sg-thumb');
      function show(id) {
        main.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-media-id') === String(id)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-media-id')); }); });
      g.sgShow = show;
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-sg-product]').forEach(function (sec) {
      var dataEl = sec.querySelector('script[data-sg-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent), fmt = sec.getAttribute('data-money-format');
      var idInput = sec.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      var btn = sec.querySelector('.product-form__submit'), btnText = btn && btn.querySelector('span');
      var priceEl = sec.querySelector('[data-sg-price]'), gallery = sec.querySelector('[data-sg-gallery]');
      var fieldsets = sec.querySelectorAll('.sg-opt');
      function selected() {
        return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      }
      function update() {
        var opts = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) { if (btn) { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = btn.getAttribute('data-unavailable'); } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = money(v.price, fmt) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price, fmt) + '</s>' : '');
        if (btn) {
          if (v.available) { btn.removeAttribute('disabled'); if (btnText) btnText.textContent = btn.getAttribute('data-add'); }
          else { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = btn.getAttribute('data-soldout'); }
        }
        if (v.featured_media && gallery && gallery.sgShow) gallery.sgShow(v.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      sec.querySelectorAll('[data-sg-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10);
            input.value = Math.max(1, n);
          });
        });
      });
    });
  }

  function initAddons(root) {
    (root || document).querySelectorAll('[data-sg-addon-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('.sg-addon');
        var input = card.querySelector('input[name="id"]');
        var opt = sel.options[sel.selectedIndex];
        if (input) input.value = sel.value;
        var price = card.querySelector('[data-sg-addon-price]');
        if (price && opt) price.textContent = opt.getAttribute('data-price');
        var btn = card.querySelector('button[type="submit"]');
        if (btn) { if (opt && opt.getAttribute('data-available') === 'false') btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled'); }
      });
    });
  }

  function initAll(root) { initReveal(root); initCountUp(root); initScan(root); initGallery(root); initProduct(root); initAddons(root); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();